import { render } from "./product.vue?vue&type=template&id=75fbc626&scoped=true"
import script from "./product.vue?vue&type=script&lang=js"
export * from "./product.vue?vue&type=script&lang=js"

import "./product.vue?vue&type=style&index=0&id=75fbc626&lang=less&scoped=true"

import exportComponent from "D:\\workstudio\\website67\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75fbc626"]])

export default __exports__